export const domAttrSet = (dom, attrs) => {
    for (let a in attrs) {
        let v = attrs[a]
        if (v===undefined) {
            dom.removeAttribute(a)
        } else {
            dom.setAttribute(a, v)
        }
    }
}


// WEBPACK FOOTER //
// ./src/twd/dom.js